import { render } from "./App.vue?vue&type=template&id=79f13057"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=79f13057&lang=css"

import exportComponent from "/srv/paginasupea/enfermeria/2026-Pagina_area_salud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__